module.exports = __webpack_public_path__ + "94008e69aaf05da75c0bbf8f8bb0db41.woff2";